import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';

@Component({
  props: {
    list: {
      type: Array,
      default: () => []
    },
    activeFont: {
      type: Object,
      default: null
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class FontContent extends Vue {
  mounted() {
  }
  selectFont(font, index) {
    this.$emit('select-font', font)
  }
  downloadFont(font) {
    this.$emit('download-font', font)
  }
}